<template>
  <el-dialog
    title="添加图片"
    :visible="visible"
    :append-to-body="true"
    width="30%"
    @close="close"
  >
    <div>
      <el-upload
        class="upload-demo"
        drag
        :action="action"
        multiple
        :data="updateMapData"
        :headers="token"
        :on-success="uploadSuccess"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">点击上方选择图片上传</div>
      </el-upload>
    </div>
  </el-dialog>
</template>
<script>
export default {
  name: "updateImg",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    orgId: {
      type: String,
      default: "",
    },
    placeId: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      token: {
        authorization: `Bearer ${localStorage.getItem("_token")}`,
      },
      updateMapData: {},
      action: `${this.$api.baseURL()}/yxzl/sysFileInfo/upload`,
    };
  },
  mounted() {
    if (this.type == "avatar") {
      this.updateMapData = {
        orgId: this.orgId,
      };
    } else {
      this.updateMapData = {
        orgId: this.orgId,
        placeId: this.placeId,
      };
    }
  },
  methods: {
    close() {
      this.$emit("close");
    },
    uploadSuccess(e) {
      this.$emit("success");
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/pc/publicPage/updateImg.vue